<!--Created by 曾伟城 on 2021/1/26.-->
<template>
  <div class="kpi-ward">
    <div class="title">{{ generalInfo.title }}</div>
    <div class="select">
      <van-cell-group class="cell-group">
        <van-field readonly clickable name="picker" input-align="right"
                   right-icon="arrow" :value="search.generalValue" label="战区" placeholder="点击选择战区" @click="showGeneralList('1')"/>
        <van-field readonly clickable name="picker" input-align="right"
                   right-icon="arrow" :value="search.legionValue" label="军团" placeholder="点击选择军团" @click="showLegionList"/>
        <van-field readonly clickable name="picker" input-align="right"
                   right-icon="arrow" :value="search.brandValue" label="品牌" placeholder="点击选择品牌" @click="showBrandList"/>
        <van-field readonly clickable name="picker" input-align="right"
                   right-icon="arrow" :value="search.shopValue" label="门店" placeholder="点击选择门店" @click="showShopList"/>
      </van-cell-group>
    </div>
    <div class="content">
      <div class="data-desc">
        <div class="sub-title"><i></i>数据总览</div>
        <div class="desc-content">
          <div class="item" v-for="(item, index) in generalInfo.descData" :key="index">
            <div class="all">{{item.all}}</div>
            <div class="name">{{item.name}}</div>
            <div class="count">人均:{{item.count}}</div>
          </div>
        </div>
      </div>
      <div class="data-rank">
        <div class="sub-title"><i></i>数据排行</div>
        <van-field readonly clickable name="picker" input-align="right" right-icon="arrow" :value="rankInfo.generalValue" label="战区" placeholder="点击选择战区" @click="showGeneralList('2')"/>
        <van-tabs class="mb10" :ellipsis="false" title-active-color="#3283fa" color="#3283fa" @click="onClick">
          <van-tab v-for="(item, index) in rankList" :title="item.title" :key="index"></van-tab>
        </van-tabs>
        <div class="btn-list">
          <span v-for="(item, index) in btnList" class="btn" :class="{active: item.active}" :key="index" @click="handleChangeRank(item, index)">{{ item.name }}</span>
        </div>
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了">
          <div v-for="(item, index) in list" :key="index" class="rankCell">
            <div class="one">
              <div class="left">
                <div class="sort m-r-20">{{ index + 1 }}</div>
                <div class="name">{{ item.kpiUserName }}</div>
              </div>
              <div class="right">{{ item.num }}</div>
            </div>
            <div class="two p-l-26" v-if="item.name">{{ item.name }}</div>
            <div class="three p-l-26" :class="{ 'm-t-8': !item.name, 'm-t-4': item.name}">
              <van-slider disabled v-model="item.score" class="m-h-12" bar-height="6px">
                <template #button>
                  <div class="custom-button"></div>
                </template>
              </van-slider>
            </div>
          </div>
        </van-list>
      </div>
    </div>
    <van-popup v-model="showWard" position="bottom">
      <van-picker show-toolbar title="切换战区" value-key="name" :columns="wardColumns" @confirm="wardConfirm" @cancel="showWard = false" :default-index="search.generalIndex"/>
    </van-popup>
    <van-popup v-model="showRankWard" position="bottom">
      <van-picker show-toolbar title="切换战区" value-key="name" :columns="wardColumns" @confirm="wardRankConfirm" @cancel="showRankWard = false" :default-index="rankInfo.generalIndex"/>
    </van-popup>
    <van-popup v-model="showLegion" position="bottom">
      <van-picker show-toolbar title="切换军团" value-key="name" :columns="legionColumns" @confirm="legionConfirm" @cancel="showLegion = false" :default-index="search.legionlIndex"/>
    </van-popup>
    <van-popup v-model="showBrand" position="bottom">
      <van-picker show-toolbar title="切换品牌" value-key="name" :columns="brandColumns" @confirm="brandConfirm" @cancel="showBrand = false" :default-index="search.brandIndex"/>
    </van-popup>
    <van-popup v-model="showShop" position="bottom">
      <van-picker show-toolbar title="切换门店" value-key="name" :columns="shopColumns" @confirm="shopConfirm" @cancel="showShop = false" :default-index="search.shopIndex"/>
    </van-popup>
    <back-home
      :activity_id="activityID"
      :user_id="user_id"
      :kpi_uid="kpi_userid"
      :share_uid="share_userid"
    ></back-home>
  </div>
</template>

<script>
import backHome from "../../components/back-home.vue";
  export default {
    components: {
      backHome,
    },
    name: "kpi-ward",
    data() {
      return {
        activityID: localStorage.getItem('act_id'),
        user_id: localStorage.getItem('user_id'),
        kpi_userid: localStorage.getItem('kpi_user_id') || null,
        share_userid: localStorage.getItem('share_user_id') || null,
        search: {
          generalValue: '全部',
          legionValue: '全部',
          brandValue: '全部',
          shopValue: '全部',
        },
        rankInfo: {
          generalValue: '全部',
          generalId: null,
          viewType: 1,
          type: 'view'
        },
        showWard: false,
        showRankWard: false,
        showLegion: false,
        showBrand: false,
        showShop: false,
        wardRankValue: '全部',
        wardColumns: [],
        legionColumns: [],
        brandColumns: [],
        shopColumns: [],
        generalInfo: {
          title: '全国联动',
          descData: [
            {all: 0, name: '浏览', count: 0},{all: 0, name: '裂变', count: 0}, {all: 0, name: '售卡', count: 0},
            {all: 0, name: '集赞', count: 0},{all: 0, name: '秒杀', count: 0}, {all: 0, name: '直播贡献签单', count: 0},
            {all: 0, name: '直播预约', count: 0},{all: 0, name: '进入直播间', count: 0},{all: 0, name: '直播下订', count: 0}
          ]
        },
        rankList: [
          {title: '浏览', type: 'view'}, {title: '裂变', type: 'fission'}, {title: '售卡', type: 'card'},
          {title: '集赞', type: 'thumb'}, {title: '秒杀', type: 'seckill_user'}, {title: '直播贡献签单', type: 'live_other_order'},
          {title: '直播预约', type: 'appointment'}, {title: '进入直播间', type: 'live_view'}, {title: '直播下订', type: 'live_order_cus'}
        ],
        btnList: [{name: '军团', active: true, type: 1}, {name: '品牌', active: false, type: 2}, {name: '门店', active: false, type: 3}, {name: '员工', active: false, type: 4}],
        list: [],
        loading: false,
        finished: false,
      }
    },
    methods: {
      // 打开战区列表
      showGeneralList (idx) {
        let params = {
          actId: Number(this.activityID),
          page: -1,
          size: -1
        }
        this.$kpi.rank.getGeneralList(params).then((res) => {
          if(res.code === 0) {
            if (!res.data.list.length) {
              this.wardColumns = [{name: '全部', id: null}]
            } else {
              this.wardColumns = res.data.list;
              this.wardColumns.push({name: '全部', id: null})
            }
            if (idx === '1') {
              this.showWard = true;
            } else {
              this.showRankWard = true
            }
          } else {
            this.$toast("暂无更多战区");
          }
        })
      },
      wardConfirm(value, index) {
        // 选择战区时,清空其他选项
        if (value) {
          this.search = {}
          this.search.generalValue = value.name;
          this.search.generalId = value.id;
          this.search.generalIndex = index
          this.getAllActData()
        }
        this.showWard = false;
      },
      wardRankConfirm(value, index) {
        if (value) {
          this.rankInfo.generalValue = value.name
          this.rankInfo.generalId = value.id
          this.rankInfo.generalIndex = index
        }
        this.showRankWard = false;
        this.getGeneralRankList()
      },
      // 打开军团列表
      showLegionList () {
        let params = {
          actId: Number(this.activityID),
          generalId: Number(this.search.generalId),
          page: -1,
          size: -1
        }
        this.$kpi.achieve.getLegionList(params).then(res => {
          if(res.code === 0) {
            // this.legionColumns = res.data.list;
            if (!res.data.list.length) {
              this.legionColumns = [{name: '全部', id: null}]
            } else {
              this.legionColumns = res.data.list;
              this.legionColumns.push({name: '全部', id: null})
            }
            this.showLegion = true;
          } else {
            this.$toast("暂无更多军团");
          }
        })
      },
      legionConfirm(value, index) {
        if (value) {
          this.search.legionValue = value.name;
          this.search.catId = value.id;
          this.search.legionlIndex = index;
          // 选择军团,清空品牌和店铺
          this.search.brandValue = ''
          this.search.brandID = null
          this.search.brandIndex = null
          this.search.shopValue = ''
          this.search.shopID = null
          this.search.shopIndex = null
          this.getAllActData()
        }
        this.showLegion = false;
      },
      // 打开品牌列表
      showBrandList () {
        let params = {
          actId: Number(this.activityID),
          generalId: Number(this.search.generalId),
          catId: Number(this.search.catId),
          page: -1,
          size: -1
        }
        this.$kpi.achieve.getRrandList(params).then(res => {
          if(res.code === 0) {
            // this.brandColumns = res.data.list;
            if (!res.data.list.length) {
              this.brandColumns = [{name: '全部', id: null}]
            } else {
              this.brandColumns = res.data.list;
              this.brandColumns.push({name: '全部', id: null})
            }
            this.showBrand = true;
          } else {
            this.$toast("暂无更多品牌");
          }
        })
      },
      brandConfirm(value, index) {
        if (value) {
          this.search.brandValue = value.name;
          this.search.brandId = value.id;
          this.search.brandIndex = index;
          this.search.shopValue = ''
          this.search.shopID = null
          this.search.shopIndex = null
          this.getAllActData()
        }
        this.showBrand = false;
      },
      // 打开门店列表
      showShopList () {
        if (!this.search.brandId) {
          this.$toast("请先选择品牌");
          return
        }
        let params = {
          actId: Number(this.activityID),
          generalId: Number(this.search.generalId),
          catId: Number(this.search.catId),
          brandId: Number(this.search.brandId),
          page: -1,
          size: -1
        }
        this.$kpi.achieve.getStoreList(params).then(res => {
          if(res.code === 0) {
            // this.shopColumns = res.data.list;
            if (!res.data.list.length) {
              this.shopColumns = [{name: '全部', id: null}]
            } else {
              this.shopColumns = res.data.list;
              this.shopColumns.push({name: '全部', id: null})
            }
            this.showShop = true;
          } else {
            this.$toast("暂无更多门店");
          }
        })
      },
      shopConfirm(value, index) {
        if (value) {
          this.search.shopValue = value.name;
          this.search.shopId = value.id;
          this.search.shopIndex = index;
          this.getAllActData()
        }
        this.showShop = false;
      },
      // 全国联动
      getAllActData () {
        let params = {
          actId: Number(this.activityID),
          generalId: this.search.generalId || null,
          catId: this.search.catId || null,
          brandId: this.search.brandId || null,
          shopId: this.search.shopId || null,
        }
        this.$kpi.rank.getAllActData(params).then(res => {
          if (res.code === 0) {
            let result = res.data
            this.generalInfo.title = result.actName ? `【${result.actName}】全国联动` : '全国联动'
            this.generalInfo.descData.forEach((item, index) => {
              switch (index) {
                case 0:
                  item.all = result.actData.viewNum || 0
                  item.count = result.avgActData.viewNum || 0
                  break
                case 1:
                  item.all = result.actData.fissionNum || 0
                  item.count = result.avgActData.fissionNum || 0
                  break
                case 2:
                  item.all = result.actData.cardNum || 0
                  item.count = result.avgActData.cardNum || 0
                  break
                case 3:
                  item.all = result.actData.thumbNum || 0
                  item.count = result.avgActData.thumbNum || 0
                  break
                case 4:
                  item.all = result.actData.seckillUserNum || 0
                  item.count = result.avgActData.seckillUserNum || 0
                  break
                case 5:
                  item.all = result.actData.liveOtherOrderNum || 0
                  item.count = result.avgActData.liveOtherOrderNum || 0
                  break
                case 6:
                  item.all = result.actData.appointmentNum || 0
                  item.count = result.avgActData.appointmentNum || 0
                  break
                case 7:
                  item.all = result.actData.liveViewNum || 0
                  item.count = result.avgActData.liveViewNum || 0
                  break
                case 8:
                  item.all = result.actData.liveOrderCusNum || 0
                  item.count = result.avgActData.liveOrderCusNum || 0
                  break
              }
            })
          }
        })
      },
      // 战区列表
      getGeneralRankList () {
        this.list = []
        let params = {
          actId: Number(this.activityID),
          ...this.rankInfo
        }
        this.loading = true
        this.finished = false
        this.$kpi.achieve.getGeneralRankList(params).then(res => {
          this.loading = false
          this.finished = true
          if (res.code === 0) {
            this.list = res.data.map(item => {
              return {
                kpiUserName: this.rankInfo.viewType === 1 ? item.catName : this.rankInfo.viewType === 2 ? item.brandName : this.rankInfo.viewType === 3 ? item.shopName : item.kpiUserName,
                score: item.score,
                num: item.num,
                name: this.rankInfo.viewType === 2 ? item.catName :
                      this.rankInfo.viewType === 3 ? item.brandName + `  (${item.catName})` :
                      this.rankInfo.viewType === 4 ? (item.shopName ? item.shopName + ' - ' : '')  + ` ${item.brandName} - ` + ` ${item.catName}` : ''
              }
            })
          }
        })
      },
      // 数据排行按钮交互
      handleChangeRank(item, index) {
        this.btnList.forEach(i => {
          i.active = false
        })
        this.btnList[index].active = true
        this.rankInfo.viewType = item.type
        this.getGeneralRankList()
      },
      onClick(name) {
        this.rankInfo.type = this.rankList[name].type
        this.getGeneralRankList()
      }
    },
    created() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      this.getAllActData()
      this.getGeneralRankList()
    }
  }
</script>

<style scoped lang="less">
.van-hairline--top-bottom::after {
  border: none;
}
.van-cell {
  height: 38px;
}
.van-tabs {
  /deep/ .van-tab--complete {
    margin-right: 6px!important;
  }
}
.sub-title {
  font-size: 12px;
  font-weight: 700;
  i {
    width: 3px;
    height: 12px;
    background-color: #155BD4;
    display: inline-block;
    margin-right: 10px;
    vertical-align: top;
  }
}
.kpi-ward {
  .title {
    color: #333;
    font-size: 13px;
    font-weight: 700;
    padding-top: 15px;
    text-align: center;
    background-color: #fff;
  }
  .select {
    background-color: #fff;
  }
  .content {
    background-color: #fff;
    margin-top: 5px;
    padding: 15px 15px 20px;
    .data-desc {
      .desc-content {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin: 5px 0 15px;
        .item {
          width: 30%;
          background-color: #E2EDFF;
          border: 1px solid #6C6CA7;
          text-align: center;
          margin: 5px 0;
          padding: 6px 0;
          .all {
            color: #47007F;
            font-size: 13px;
            font-weight: 700;
          }
          .name {
            color: #6C6CA7;
            margin: 2px 0;
          }
          .count {
            color: #7F7F7F;
          }
        }
      }
    }
    .data-rank {
      .btn-list {
        .btn {
          margin-right: 6px;
          padding: 7px 12px 5px;
          border-radius: 3px;
          display: inline-block;
          background-color: #F2F2F2;
        }
        .active {
          background-color: #3283fa;
          color: #fff;
        }
      }
    }
  }
  .rankCell {
    padding: 10px 20px 8px 10px;
    border-bottom: 1px solid rgba(235,237,240,0.5);
    .one {
      display: flex;
      font-size: 13px;
      font-weight: 600;
      justify-content: space-between;
      .left {
        display: flex;
        .sort {
          color: #6C6CA7;
        }
      }
    }
    .two {
      margin-top: 2px;
      color: #AAA;
    }
  }
  .p-l-26 {
    padding-left: 28px;
  }
  .m-t-8 {
    margin-top: 10px;
  }
  .m-t-4 {
    margin-top: 6px;
  }
  .m-r-20 {
    margin-right: 20px;
  }
}
</style>